import loadable from "@loadable/component";

export const LoginForm = loadable(() => import("./LoginForm/loginForm"));
export const SignUpForm = loadable(() => import("./SignupForm/signupForm"));
export const ChangePasswordForm = loadable(() =>
  import("./ChangePassword/index")
);
export const ProfileForm = loadable(() => import("./ProfileForm/profileForm"));
